import { render, staticRenderFns } from "./Mesh.vue?vue&type=template&id=5b08152a&"
import script from "./Mesh.vue?vue&type=script&lang=js&"
export * from "./Mesh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports